module.exports = __webpack_public_path__ + "img/img_3_style.0787e681.png";